/**
 * Distintivo de estado: punto de color + etiqueta. Los cuatro tonos se derivan siempre de un
 * dato (estado de cobro, severidad de alerta, prioridad de incidencia), nunca se eligen a mano
 * en la pantalla.
 */
import type { ReactNode } from 'react';
import styles from './Badge.module.css';

export type BadgeTone = 'success' | 'warning' | 'danger' | 'neutral';

interface BadgeProps {
  children: ReactNode;
  tone?: BadgeTone;
  size?: 'default' | 'sm' | 'kanban';
}

const TONE: Record<BadgeTone, string> = {
  success: styles.success!,
  warning: styles.warning!,
  danger: styles.danger!,
  neutral: styles.neutral!,
};

const SIZE = {
  default: '',
  sm: styles.sm!,
  kanban: styles.kanban!,
};

export function Badge({ children, tone = 'neutral', size = 'default' }: BadgeProps) {
  return <span className={`${styles.badge} ${SIZE[size]} ${TONE[tone]}`}>{children}</span>;
}

/**
 * Distintivo de documentación: verde con ✓ si el documento existe, gris apagado si no.
 * El estado viene DERIVADO de la tabla `documents`; no hay booleanos almacenados.
 */
export function DocumentBadge({ label, present }: { label: string; present: boolean }) {
  return (
    <span className={`${styles.doc} ${present ? styles.success : styles.neutral}`}>
      {present ? `${label} ✓` : label}
    </span>
  );
}
